<template>
  <div class="right-footer text-right">
    <img
      src="https://www.wrraptheme.com/demo/payangel/img/Powered_by_StandApp.559e4fb5.svg"
      width="180"
      alt=""
    />
  </div>
</template>
<script>
export default {
  name: "RightFooterComponent",
};
</script>
